export abstract class AuthVersionState {
  public static get(): string | null {
    return window.sessionStorage.getItem("auth-version");
  }

  public static set(value: string) {
    sessionStorage.setItem("auth-version", value);
  }

  public static clear() {
    sessionStorage.removeItem("auth-version");
  }
}
